import React, { useState, useEffect } from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
} from '@mui/material'
import { Content } from './styles'
import { useTheme } from '@mui/material/styles'
import MenuFiscalTabs from './MenuFiscalTabs'

const MenuFiscalDialog: React.FC<
    {
        setAberto: React.Dispatch<React.SetStateAction<boolean>>,
        aberto: boolean
    }> = ({ setAberto, aberto }) => {

        const theme = useTheme()
        const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
        const [activeTab, setActiveTab] = useState(0)

        const CONFIGURACAO_FISCAL_TAB = 4
        const abaConfiguracaoFiscal = activeTab === CONFIGURACAO_FISCAL_TAB

        return (
            <Dialog
                fullScreen={fullScreen}
                fullWidth={abaConfiguracaoFiscal}
                maxWidth={abaConfiguracaoFiscal ? 'lg' : 'sm'}
                open={aberto}
                onClose={_ => setAberto(false)}
            >
                <DialogTitle id="menufiscal-dialog">
                    {"Menu Fiscal"}
                </DialogTitle>
                <DialogContent>
                    <Content id="menufiscal-box" component="section">
                        <MenuFiscalTabs onTabChange={setActiveTab} />
                    </Content>
                </DialogContent>
                <DialogActions>
                        <Button onClick={_ => setAberto(false)}>Fechar</Button>
                </DialogActions>
            </Dialog>
        )
    }

export default MenuFiscalDialog;